<template>
  <custom-dialog
    class="update-sim-network-flow-dialog"
    width="1400px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
  >
    <div class="dialog-body">
      <custom-table
        :data="tableList"
        :column="tableColumn"
        height="400px"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['istSendLimit', 'istRecvLimit']"
      >

        <template v-slot:istSendLimit="scope">
          <el-input
            v-model="scope.row.istSendLimit"
            type="number"
            min="0"
          ></el-input>
        </template>
        <template v-slot:istRecvLimit="scope">
          <el-input
            v-model="scope.row.istRecvLimit"
            type="number"
            min="0"
          ></el-input>
        </template>
      </custom-table>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="closeDialog">
        {{ $t('Common.com_cancel') }}
      </el-button>
      <el-button
        type="primary"
        @click="onConfirm"
      >
        {{ $t('Common.com_confirm') }}
      </el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis.js';

export default {
  mixins: [dialogMixins],
  props: {},
  data() {
    return {
      tableCode: 'update_sim_network_flow',
      tableList: [],
    };
  },
  methods: {
    // 判断非负数
    checkNum(num) {
      const number = String(num);

      // 判断是否为合法数字
      const p = /^[0-9]+(\.[0-9]+)?$/g;
      return p.test(number);
    },
    closeDialog() {
      this.visible = false;
    },
    validate(cb) {
      const tableList = this.tableList;
      const errValType = tableList.some(item => !this.checkNum(item.istSendLimit) || !this.checkNum(item.istRecvLimit));
      if (errValType) {
        this.$message({
          message: this.$t('dms_update_sim_network_flow_dialog.qsrhfsz'),
          type: 'error'
        });
      } else {
        if (cb) {
          cb();
        }
      }
    },
    onConfirm() {
      this.validate(() => {
        const reqData = this.getSubmitReqData();
        this.$postJSON(apis.simIstDataLimitBatchUpdate, reqData).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success'
          });
          this.$emit('success');
          this.closeDialog();
        });
      });

    },
    init() {
      this.getTableColumn();
      const simIds = this.model.data.selectedSim.map(item => item.simId);
      this.$getJSON(apis.simListByIds, { simIds }).then((res) => {
        this.tableList = this.listFilter(res.data);
      });
    },
    listFilter(list) {
      list.forEach((item) => {
        item.istSendLimit = 0;
        item.istRecvLimit = 0;
      });
      return list;
    },
    del(index) {
      this.tableList.splice(index, 1);
    },
    getSubmitReqData() {
      const ret = this.tableList.map((item) => {
        const obj = {
          istRecvLimit: Number(item.istRecvLimit),
          istSendLimit: Number(item.istSendLimit),
          simId: item.simId,
        };
        return obj;
      });
      return ret;
    }

  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss">
.update-sim-network-flow-dialog {
  .btn-content {
    padding: 10px 0;
    .add-relation-data {
      width: 100%;
      margin: 10px 0;
      background: whitesmoke;
      border: 1px dashed #e4e4e4;
      color: #333333;
      font-size: 12px;
      .icon-add {
        color: #00afff;
        font-size: 10px;
        margin-right: 0px;
      }
    }
  }
}
</style>
